module.exports = __webpack_public_path__ + "img/yt.f06d254d.svg";